export const getQtyForMultipack = (multipacksQuantities, option_id) => {
    const item = multipacksQuantities.find((item) => item.option_id === option_id);
    return item?.qty ?? 0;
};
//# sourceMappingURL=getQtyForMultipack.js.map